/**
 * @generated SignedSource<<029ea44ab7ecd325c912230faecf2943>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
import { FragmentRefs } from "relay-runtime";
export type WidgetFile_widgetFile$data = {
  readonly files: ReadonlyArray<{
    readonly file: {
      readonly id: string;
      readonly status: FileStatus;
    };
  }>;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFileDynamic_widgetFile" | "WidgetFileStatic_widgetFile">;
  readonly " $fragmentType": "WidgetFile_widgetFile";
};
export type WidgetFile_widgetFile$key = {
  readonly " $data"?: WidgetFile_widgetFile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFile_widgetFile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetFile_widgetFile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetFileEdge",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "file",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetFileStatic_widgetFile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetFileDynamic_widgetFile"
    }
  ],
  "type": "WidgetFile",
  "abstractKey": null
};
})();

(node as any).hash = "b0c83a13e0347abb86bc8bb000758409";

export default node;
